import { inject, injectable } from '~/container'
import { getLangFallbackUrl } from '~/lang/utils/langfetch'
import { PuFetchInstance } from '~/utility/http'
import { SYMBOLS } from '../inversify/symbols'
import { GuestBookingsRepository } from './repositories'
import { bookingSchema, GuestBooking, GuestBookingBooking } from './schema'

@injectable()
export class GuestBookingRepositoryFetch implements GuestBookingsRepository {
  @inject(SYMBOLS.PuFetchInstance)
  private puFetch: PuFetchInstance

  async getByToken(token: string, langCode: string): Promise<GuestBooking> {
    const result: GuestBookingFetchResult = await this.puFetch.get(
      this.getUrl(token, langCode),
    )
    if (result.userBooking) {
      const booking = this.mapResponse(result.userBooking, token)
      return { error: result.error, booking }
    }
    return {
      error: result.error,
      booking: result.userBooking,
      reviewId: result.reviewId,
    }
  }

  private getUrl(token: string, langCode: string) {
    return getLangFallbackUrl(langCode, `/_/endpoints/guest-booking/${token}/`)
  }

  private mapResponse(
    userBooking: GuestBookingResponse,
    token: string,
  ): GuestBookingBooking {
    const result = bookingSchema.parse({
      ...userBooking,
      token,
    })
    const categories = userBooking.pitchtype?.categories || undefined
    if (result && categories) result['categories'] = categories.map((c) => c.id)
    const primaryPhoto = userBooking.pitchtype?.primaryPhoto || undefined
    if (result && primaryPhoto)
      result['primaryPhoto'] = {
        url: { masterImage: primaryPhoto.url.master_image },
      }
    return result
  }
}

interface GuestBookingResponse {
  arrive: string
  depart: string
  prettyId: string
  status: number
  pitchtype?: {
    categories: Array<{ id: string }>
    primaryPhoto?: { url: { master_image: string } }
  }
}

interface GuestBookingFetchResult {
  userBooking?: GuestBookingResponse
  error: string
  reviewId?: string
}
